import Thumbnail from './thumbnail.png';

const title = 'Soft-body Tetrahedral Simulation';
const description = `Soft-body simulation based on tetrahedral meshes, implemented in C++.`;

export default {
  title,
  description,
  thumbnail: Thumbnail,
  href: 'https://www.youtube.com/watch?v=sQXepdWgsjE',
};
